import { render, staticRenderFns } from "./pluginDashboard.vue?vue&type=template&id=6936e083&scoped=true"
import script from "./pluginDashboard.vue?vue&type=script&lang=js"
export * from "./pluginDashboard.vue?vue&type=script&lang=js"
import style0 from "./pluginDashboard.vue?vue&type=style&index=0&id=6936e083&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6936e083",
  null
  
)

export default component.exports